import { gql } from "@apollo/client";

export default gql`
  query getOrganizationTemplatesQuery {
    topicTemplates(publicTemplate: true, globalTemplate: false) {
      edges {
        node {
          id
          title
        }
      }
    }
  }
`;
